import axios from "../api/axios";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getRoute } from "../utils/routes";
import { useAuth } from "../context/AuthContext";
import { RiArrowRightCircleLine, RiEditBoxLine } from "react-icons/ri";
import { Link } from "react-router-dom";

function Ticket() {
  const [ticket, setTicket] = useState([]);
  const [paginasTotales, setPaginasTotales] = useState(1);
  const [busqueda, setBusqueda] = useState("");
  const [pagina, setPagina] = useState(1);
  const { user } = useAuth();
  const [refresh, setRefresh] = useState(0);

  window.refreshTickets = setRefresh;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint = busqueda
          ? `/api/busqueda/baveria?q=${busqueda}&page=${pagina}`
          : `/api/tickets?page=${pagina}`;

        const res = await axios.get(endpoint);
        setTicket(res.data.ticket);
        setPaginasTotales(res.data.paginasTotales || 1);
      } catch (error) {
        console.error("Error al obtener tickets:", error);
      }
    };

    fetchData();
  }, [refresh, busqueda, pagina]);

  return (
    <div className="px-4 min-h-[calc(100vh-6rem)]">
      <h1 className="p-3 px-5 font-bold small-2xl uppercase">Averías</h1>

      <input
        type="text"
        className="w-full p-3 font-bold border border-secondary-900 text-black rounded mb-4"
        placeholder="Nº Abonado/Nombre/Dirección/Población..."
        value={busqueda}
        onChange={(e) => {
          setBusqueda(e.target.value);
          setPagina(1);
        }}
      />

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {Array.isArray(ticket) && ticket.length > 0 ? (
          ticket.map((p) => (
            <div
              key={p.ticket_id}
              className="flex flex-col justify-between bg-secondary-900 p-4 rounded-xl h-[300px] overflow-hidden"
            >
              <div>
                <div className="flex justify-between items-center font-bold text-mid uppercase mb-2">
                  <span>Nº Abonado: {p.cliente_id}</span>

                  <div className="flex gap-2">
                    <Link
                      to={getRoute(user, `pdfTicket/${p.ticket_id}`)}
                      className="flex items-center me-5"
                    >
                      <RiEditBoxLine size={20} />
                    </Link>
                    <Link
                      to={getRoute(user, `editTicket/${p.ticket_id}`)}
                      className="flex items-center me-5"
                    >
                      <RiArrowRightCircleLine size={20} />
                    </Link>
                  </div>
                </div>
                <div>
                  <h1 className="font-bold text-mid uppercase mb-2">
                    Nombre: {p.nombre}
                  </h1>
                  <h1 className="font-bold text-mid uppercase mb-2">
                    Dirección: {p.direccion}
                  </h1>
                  <h1 className="font-bold text-mid uppercase mb-2">
                    Poblacion: {p.poblacion}
                  </h1>
                </div>
                <div>
                  <h1 className="font-bold text-mid uppercase mb-2">
                    Contacto: {p.ncontacto}
                  </h1>
                  <h1 className="font-bold text-mid uppercase mb-2">
                    Teléfono: {p.telefono}
                  </h1>
                  <h1 className="font-bold text-mid uppercase mb-2">
                    Tipo de Averia: {p.tipoaveria}
                  </h1>
                </div>
                <h1 className="text-justify font-bold text-mid uppercase overflow-hidden line-clamp-3 mb-2">
                  Descripción:{" "}
                  {p.descripcion.length > 200
                    ? p.descripcion.slice(0, 200) + "..."
                    : p.descripcion}
                </h1>
                <h1 className="font-bold text-mid uppercase mb-2">
                  Fecha: {dayjs(p.fecha).format("DD-MM-YYYY")}
                </h1>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center py-4 font-bold uppercase">
            No se encontraron averías
          </div>
        )}
      </div>

      {/* Botones de paginación */}
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
          disabled={pagina === 1}
          onClick={() => setPagina(pagina - 1)}
        >
          Anterior
        </button>

        <span>
          Página {pagina} de {paginasTotales}
        </span>

        <button
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
          disabled={pagina >= paginasTotales}
          onClick={() => setPagina(pagina + 1)}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}

export default Ticket;
